module.exports = __webpack_public_path__ + "static/media/bigwave.ef57cbb3.svg";